import type { JSX } from 'react';
import { Button } from '@c2fo/liquidity';
import { ArrowRightIcon } from '@c2fo/liquidity/icons';
import { CONTINUE_TO_MONDU_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

interface ContinueToMonduProps {
  /** Receives the rendered label so the page reports the copy the supplier actually saw. */
  onCtaClick: (ctaLabel: string) => void;
  /** Set while this CTA's own handoff is in flight. */
  ctaLoading?: boolean;
  /** Set while any handoff is in flight, so a second click cannot start a second one. */
  ctaDisabled?: boolean;
}

const ContinueToMondu = ({
  onCtaClick,
  ctaLoading = false,
  ctaDisabled = false,
}: ContinueToMonduProps): JSX.Element => {
  return (
    <div className="flex flex-col items-center space-y-6 rounded-2xl bg-secondary-500 px-6 py-8 text-center text-white shadow-md md:px-12 md:py-8">
      <p className="text-3xl md:text-4xl">{CONTINUE_TO_MONDU_CONTENT.headline}</p>
      <p className="max-w-3xl text-base md:text-lg">{CONTINUE_TO_MONDU_CONTENT.body}</p>
      <div className="flex">
        <Button
          variant="primary"
          inverse
          loading={ctaLoading}
          disabled={ctaDisabled}
          onClick={() => onCtaClick(CONTINUE_TO_MONDU_CONTENT.ctaLabel)}
        >
          <span className="flex items-center gap-2">
            {CONTINUE_TO_MONDU_CONTENT.ctaLabel}
            <ArrowRightIcon className="h-5 w-5" aria-hidden />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default ContinueToMondu;
